import React from "react";

const EmailVerificationPage = () => {
  return <div>EmailVerificationPage</div>;
};

export default EmailVerificationPage;
